<template>
    <td v-if="day.type == 'next'" tabindex="0" aria-haspopup="dialog"
        role="gridcell" :aria-label="full_date(day.date)"
        @keyup.enter="products.length > 0 ? showPopUp(0, -1) : null"
        @keyup.space.prevent="products.length > 0 ? showPopUp(0, -1) : null"
        @click="checkActiveWeekCycle(day.date)"
        @focus="checkActiveWeekCycle(day.date)"
        class="pt-1 border-r-2 border-b-8 p-color last-td-background shadow-lg pb-6 td-width align-top relative box-hover bg-white focus:ring-2 focus:ring-[#38558e] focus:z-10 outline-none"
        >

        <div class="flex bg-white" :class="{ 'ring-2 ring-[#38558e] border-2 border-[#38558e] z-20': activeDay == day.date }">
            <div class="flex lg:flex-nowrap pl-2">
                <div class="week-cycle-fontsize week-cycle-color font-bold pr-2 pt-2">
                    {{ format_date(day.date) }}
                </div>

            </div>

            <div v-if="products.length == 0 && dayType == 'image' && verifyExcludeDay(day.date) === false"
                class="flex justify-center flex-col items-center w-full -ml-2 mt-5 p-1">
                <img :src="$page.props.asset_url + '/images/no-food-sign2.jpg'"
                    class="w-full h-full object-cover p-1 opacity-70" alt="No food sign">
            </div>



            <div v-if="products.length > 0 && isShowMenu(day) && verifyExcludeDay(day.date) === false && dayType == 'image'"
                class="color-24 text-sm block divl-2 w-full">
                <div v-if="products.length == 1" class="flex w-full h-full mh-135 relative box-type-show"
                    style="display:block;">
                    <div v-for="(product, index) in products" class="w-full h-full cursor-pointer" @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            class="w-full h-full" :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'"
                            class="w-full h-full object-cover" :alt="product?.name || 'Product Image'">
                    </div>
                </div>

                <div v-if="products.length == 2" class="flex flex-wrap h-full mh-135  relative">
                    <div v-for="(product, index) in products" class="w-full h-1/2 relative cursor-pointer" @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">
                    </div>
                </div>

                <div v-if="products.length == 3" class="flex flex-wrap h-full mh-135 relative ">
                    <div v-for="(product, index) in products"
                        :class="[(index == 0) ? 'w-full h-1/2 box-type-show relative' : 'w-6/12 h-1/2 box-type-show relative', 'cursor-pointer']"
                        @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">
                    </div>
                </div>

                <div v-if="products.length == 4" class="flex flex-wrap h-full mh-135 relative">
                    <div v-for="(product, index) in products" class="w-6/12 h-1/2 relative cursor-pointer" @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">
                    </div>
                </div>

                <div v-if="products.length > 4" class="flex flex-wrap h-full mh-135 relative">
                    <div v-for="(product, index) in products" class="w-6/12 h-1/2 relative cursor-pointer" v-show="index < 4"
                        @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">

                    </div>

                    <div v-if="products.length > 4"
                        class="rounded-full add_food_color w-12 h-12 flex items-center justify-center absolute-items box-type-show cursor-pointer"
                        @click="showPopUp(4, -1)" aria-haspopup="dialog">
                        <p class="text-white">+{{ products.length - 4 }}</p>
                    </div>


                </div>
            </div>

            <div v-if="verifyExcludeDay(day.date) === false && isShowMenu(day) && dayType == 'list'"
                class="color-24 text-sm block divl-2  w-full">

                <div v-if="products.length > 0" class="flex w-full h-full  relative box-type-show" style="display:block;">
                    <ul v-for="(product, index) in products" class="w-full mb-4">
                        <li v-if="index < 4" class="cursor-pointer" @click="showPopUp(index, -1)"><span
                                class="w-full text-black text-base uppercase option_title cursor-pointer">{{
                                    product.name }} </span></li>
                        <li v-if="index < 4" class="cursor-pointer"
                            v-for="(menuCycleDayOptionComponents, rindex) in sortedRecipeArray(product.menu_cycle_day_option_components)"
                            @click="showPopUp(index, rindex)">
                            <a href="javascript:void(0)"> {{ menuCycleDayOptionComponents?.recipe?.show_name }}</a>
                        </li>
                    </ul>

                    <div v-if="products.length > 4"
                        class="rounded-full add_food_color w-8 h-8 flex items-center justify-center absolute-items2 box-type-show cursor-pointer"
                        @click="showPopUp(4, -1)" aria-haspopup="dialog">
                        <p class="text-white"> +{{ products.length - 4 }}</p>
                    </div>
                </div>
                <div v-else class="flex justify-center flex-col items-center w-full -ml-2 mt-5">
                    <span class="italic text-xs mt-1">Not Available!</span>
                </div>
                <div>
                </div>
            </div>



            <span v-if="verifyExcludeDay(day.date) === true"
                class="italic text-xs mb-1 bottom-0.5 left-0 right-0 absolute m-auto text-center">Not in
                session!</span>
        </div>
    </td>

    <td v-else
        class="border-r-2 pt-1 border-b-8 p-color shadow-lg pb-6 td-width align-top relative box-hover bg-white focus:ring-2 focus:ring-[#38558e] focus:z-10 outline-none"
        :class="[(((moment().isBefore(day.date) === false) && (moment().format('MM-DD-YYYY') != day.date)) || verifyExcludeDay(day.date) === true) ? 'bg-grey' : 'bg-white']"
        tabindex="0" role="gridcell" aria-haspopup="dialog" :aria-label="full_date(day.date)"
        @click="checkActiveWeekCycle(day.date)"
        @focus="checkActiveWeekCycle(day.date)"
        @keyup.enter="products.length > 0 ? showPopUp(0, -1) : null"
        @keyup.space.prevent="products.length > 0 ? showPopUp(0, -1) : null">

        <div class="flex bg-white"  :class="{ 'ring-2 ring-[#38558e] border-2 border-[#38558e] z-20': activeDay == day.date }">
            <div class="flex lg:flex-nowrap pl-2">
                <div class="week-cycle-fontsize week-cycle-color font-bold pr-2 pt-2">
                    {{ format_date(day.date) }} &nbsp;
                </div>
            </div>

            <div v-if="verifyExcludeDay(day.date) === false && isShowMenu(day) && dayType == 'image'"
                class="color-24 text-sm block divl-2 w-full">

                <div v-if="products.length == 0" class="flex w-full h-full p-1">
                    <div class="w-full h-full">
                        <img :src="$page.props.asset_url + '/images/no-food-sign2.jpg'"
                            class="w-full h-full object-cover p-1 opacity-70" alt="No food available">
                    </div>
                </div>

                <div v-if="products.length == 1" class="flex w-full h-full mh-135 relative box-type-show"
                    style="display:block;">
                    <div v-for="(product, index) in products" class="w-full h-full cursor-pointer"
                        @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'"
                            class="w-full h-full object-cover" :alt="product?.name || 'Product Image'">
                    </div>

                </div>

                <div v-if="products.length == 2" class="flex flex-wrap h-full mh-135  relative">
                    <div v-for="(product, index) in products" class="w-full h-1/2 relative cursor-pointer" @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">
                    </div>

                </div>

                <div v-if="products.length == 3" class="flex flex-wrap h-full mh-135 relative ">
                    <div v-for="(product, index) in products"
                        :class="[(index == 0) ? 'w-full h-1/2 box-type-show relative' : 'w-6/12 h-1/2 box-type-show relative', 'cursor-pointer']"
                        @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">
                    </div>

                </div>

                <div v-if="products.length == 4" class="flex flex-wrap h-full mh-135 relative">
                    <div v-for="(product, index) in products" class="w-6/12 h-1/2 relative cursor-pointer" @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">
                    </div>



                </div>

                <div v-if="products.length > 4" class="flex flex-wrap h-full mh-135 relative">
                    <div v-for="(product, index) in products" class="w-6/12 h-1/2 relative cursor-pointer" v-show="index < 4"
                        @click="showPopUp(index, -1)" aria-haspopup="dialog">
                        <img v-if="product.photo_store_path"
                            :src="$page.props.storage_image_url + product.photo_store_path + '_resize'"
                            :original="$page.props.storage_image_url + product.photo_store_path"
                            @error="$helpers.replaceByDefault" class="w-full h-full" :alt="product?.name || 'Product Image'">
                        <img v-else :src="$page.props.asset_url + '/images/pizza-icon-image.jpg'" class="w-full h-full" :alt="product?.name || 'Product Image'">

                    </div>

                    <div v-if="products.length > 4" @click="showPopUp(4, -1)" aria-haspopup="dialog"
                        class="rounded-full add_food_color w-12 h-12 flex items-center justify-center absolute-items box-type-show cursor-pointer"
                        role="button" aria-label="View more products">
                        <p class="text-white">+{{ products.length - 4 }}</p>

                    </div>
                </div>
            </div>
            <div v-if="verifyExcludeDay(day.date) === false && isShowMenu(day) && dayType == 'list'"
                class="color-24 text-sm block divl-2 w-full">

                <div v-if="products.length > 0" class="flex w-full h-full  relative box-type-show" style="display:block;">
                    <ul v-for="(product, index) in products" class="w-full mb-4">
                        <li v-if="index < 4" class="cursor-pointer" @click="showPopUp(index, -1)" aria-haspopup="dialog"><span
                                class="w-full text-black text-base uppercase option_title cursor-pointer">{{
                                    product.name }} </span></li>
                        <li v-if="index < 4"
                            v-for="(menuCycleDayOptionComponents, rindex) in sortedRecipeArray(product.menu_cycle_day_option_components)">
                            <a href="javascript:void(0)" @click="showPopUp(index, rindex)" aria-haspopup="dialog"> {{
                                menuCycleDayOptionComponents?.recipe?.show_name }}</a>
                        </li>
                    </ul>

                    <div v-if="products.length > 4"
                        class="rounded-full add_food_color w-8 h-8 flex items-center justify-center absolute-items2 box-type-show cursor-pointer"
                        @click="showPopUp(4, -1)" aria-haspopup="dialog">
                        <p class="text-white"> +{{ products.length - 4 }}</p>
                    </div>
                </div>
                <div v-else class="flex justify-center flex-col items-center w-full -ml-2 mt-5">
                    <span class="italic text-xs mt-1">Not Available!</span>
                </div>
                <div>
                </div>
            </div>
            <div class="w-full absolute button-none bottom-0-space" v-if="menuCycle && cal_days">

            </div>
            <span v-if="verifyExcludeDay(day.date) === true"
                class="italic text-xs mb-1 bottom-0.5 left-0 right-0 absolute m-auto text-center">Not in session!</span>
        </div>

    </td>
    <CalendarPopup ref="calendarPopup" :date="full_date(day.date)" :products="products" :userLoginCheck="userLoginCheck"
        @loadExcludedDateData="loadExcludedDateData" @loadCalendar="loadCalendar" />
</template>


<script>
import vClickOutside from "click-outside-vue3";
var moment = require('moment');
import JetDialogModal from "@/Jetstream/DialogModal";
import CalendarPopup from "@/Pages/ParentPortal/Home/CalendarPopup";

export default {
    directives: {
        ClickOutside: vClickOutside,
    },
    props: ['day', 'index', 'menuCycle', 'searchForm', 'week', 'excludeDays', 'isMenuPlanner', 'activeDay', 'userLoginCheck', 'dayType'],

    components: {
        vClickOutside,
        JetDialogModal,
        CalendarPopup
    },

    data() {
        return {
            pro: 1,
            log: console.log,
            cal_days: null,
            moment: moment,
            is_assembly_instructions: false,
            cart_id_for_remove: '',
            showCartIcon: false,
            showFirstModal: false,
            showSecondModal: false,
            showThirdModal: false,
            showFourthModal: false,
            showFifthModal: false,
            showSixModal: false,
        }
    },
    computed: {
        products: function () {
            this.cal_days = null;
            let $this = this;
            if (this.menuCycle) {
                console.log("Menucycleview", this.menuCycle);
                let options = [];
                this.menuCycle.menu_cycle_days.forEach(mcdays => {
                    if (mcdays.day_of_week_number - 1 == $this.index) {
                        $this.is_assembly_instructions = mcdays.is_assembly_instructions;

                        mcdays.options.forEach((option, indexs) => {
                            if (indexs == 0) {
                                option.isShowOnModal = true;
                            } else {
                                option.isShowOnModal = false;
                            }
                        });

                        options = mcdays.options;
                        $this.cal_days = mcdays;

                    }
                });

                console.log('optionssss', options);
                return options;
            } else {
                $this.is_assembly_instructions = false;
                return [];
            }
        },

    },
    watch: {
        activeDay(value) {
            if (this.day.date != value) {
                this.showFirstModal = false;
                this.showSecondModal = false;
                this.showThirdModal = false;
                this.showFourthModal = false;
                this.showFifthModal = false;
                this.showSixModal = false
            }
        }
    },
    methods: {


        sortedRecipeArray(recipe_arrays) {
            // console.log("recipe_arrays", recipe_arrays);
            let a = _.orderBy(recipe_arrays, 'recipe.name', 'asc');
            a = _.orderBy(a, 'recipe.category_sort', 'asc');
            // console.log("recipe_arrays a", recipe_arrays);
            return a;
        },

        full_date(value) {
            if (value) {
                let date;
                // Check if the browser is Safari
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (isSafari) {
                    // Safari requires the date string to be in YYYY/MM/DD format
                    const parts = String(value).split('-');
                    date = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
                } else {
                    date = new Date(value);
                }
                const options = { weekday: 'long', month: 'long', day: 'numeric' };
                return date.toLocaleDateString('en-US', options);
            }
        },

        showPopUp(index, rindex) {
            console.log("userLoginCheck", this.userLoginCheck);
            this.$refs.calendarPopup.showPopUp(index, rindex);
        },

        checkActiveWeekCycle(activeDay) {
            this.$emit('checkActiveWeekCycle', activeDay);
        },



        sortArrays(arrays) {
            return _.orderBy(arrays, 'sort_order', 'asc');
        },

        format_date(value) {
            if (value) {
                let date;
                // Check if the browser is Safari
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (isSafari) {
                    // Safari requires the date string to be in YYYY/MM/DD format
                    const parts = String(value).split('-');
                    date = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
                } else {
                    date = new Date(value);
                }
                const options = { day: 'numeric' };
                return date.toLocaleDateString('en-US', options);

                // return moment(String(value)).format('DD')
            }
        },

        getOptionName(mc) {
            if (mc.name == '') {
                return "Option " + mc.sort_order;
            } else {
                return mc.name;
            }
        },

        getPhotoStorePath(mc) {
            if (mc.photo_store_path == '') {
                return "null";
            } else {
                return this.$page.props.storage_image_url + mc.photo_store_path;
            }
        },

        loadCalendar() {
            this.$emit('loadCalendar');
        },

        loadExcludedDateData() {
            this.$emit('loadExcludedDateData');
        },

        loadExcludedDateDataOnLoad(site, guide_line_id) {
            this.$emit('loadExcludedDateDataOnLoad', site, guide_line_id);
        },

        verifyExcludeDay(current_date) {
            // console.log('excludeDays', current_date, this.excludeDays);
            if (this.excludeDays) {
                // var new_date = moment(current_date).format('MM/DD/YYYY');
                var new_date = moment(current_date, 'MM-DD-YYYY').format('MM/DD/YYYY');
                let obj = this.excludeDays.find(o => o.date === new_date);
                // console.log('excludeDays in ', current_date, this.excludeDays, new_date, obj);
                if (obj) {
                    // console.log('excludeDays in true', current_date, this.excludeDays, new_date, obj);
                    return true;
                } else {
                    return false;
                }
            }
            return false;

        },

        isShowMenu(cday) {
            return true;
        }

    }
};
</script>


<style scoped>
.box-hover .bg-white.popup-shadow {
    font-size: 12px;
    width: 460px;
}

.bg-white.popup-shadow {
    padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
    padding: 3px 8px;
    margin-bottom: 5px;
}

/* .button-none{
    bottom: -100%;
    z-index: 10;
    } */

/* .box-hover{
    overflow: hidden;
    } */
/* .box-hover:hover .button-none{
    bottom: 0;
    } */

.bottom-0-space {
    bottom: 6px;
}
</style>

<style scoped>
.box-hover .bg-white.popup-shadow {
    font-size: 12px;
    width: 460px;
}

.bg-white.popup-shadow {
    padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
    padding: 3px 8px;
    margin-bottom: 5px;
}

/* .button-none{
bottom: -100%;
z-index: 10;
} */

/* .box-hover{
overflow: hidden;
} */
/* .box-hover:hover .button-none{
bottom: 0;
} */

.bottom-0-space {
    bottom: 6px;
}
</style>

<style>
.font-24 {
    font-size: 24px;
}

.color-24 {
    color: #636363;
}

.p-color {
    color: #969696;
}

.p-size {
    font-size: 15px;
}

.online-color {
    color: #22af4b;
}

.offline-color {
    color: #cb0000;
}

.number-background-color {
    background-color: #cb0000;
}

.online-background-color {
    background-color: #22af4b;
}

.week-cycle-color {
    color: #1c2a47;
}

.week-cycle-fontsize {
    font-size: 14px;
}

.three-dot-color {
    color: #38558e;
}

.table-background {
    background-color: #f3f3f3;
}

.last-td-background {
    background-color: white !important;
    opacity: 0.7;
}

.td-width {
    width: 14.28%;
    min-height: 135px;
    min-width: 170px;
}

.td-width .absolute-div {
    left: 35px;
}

.cart-color {
    color: #f7a53a;
}

.plus-font-size {
    font-size: 20px;
}

.menu-day-background {
    background-color: #cbcbcb;
}

.box-sizing {
    width: 100px;
    min-height: 60px;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.w-52 {
    width: 185px;
    width: 185px;
    max-height: 161px;
    overflow: auto;
    overflow-x: hidden;
}

.w-3 {
    width: 60px;
    height: 60px;
}

.hover_font_size {
    font-size: 13px;
    font-weight: bold;
    text-decoration: underline;
}

.title_color {
    color: #f7a53a;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.show-box {
    display: block !important;
}

.hide-box {
    display: none !important;
}

/* .box-type-show:hover .show-box {
    display: block;
} */

.absolute-div {
    position: absolute;
    top: 0px;
    left: 50px;
}

.add_food_color {
    background-color: #38558e;
}

.absolute-items {
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: 0px;
    margin: auto;
}

.absolute-items2 {

    position: absolute;
    right: 8px;
    bottom: 8px;
    margin: auto;
}

.text-color-circle-icon {
    color: #38558e;
}

.mh-135 {
    height: 215px;
    padding: 4px;
}

.mh-135>div {
    padding: 4px;
}

.mh-135>div img {
    object-fit: cover;
}

span.option_title {
    line-height: 17px;
    padding-bottom: 10px;
}
</style>
